import { gql } from "@apollo/client";
export default gql`
    query GetWorksheetIdByNestedBlockId($blockId: Int!) {
        worksheet_worksheet_block_map(
            where: {
                block: { children: { children: { id: { _eq: $blockId } } } }
            }
        ) {
            worksheet_id
            block {
                id
                data(path: "progress_level.name")
                children {
                    id
                    order
                    children {
                        id
                        order
                    }
                }
            }
        }
    }
`;
